import detailStyles from '../ChallengeDetail.module.scss';
import image121 from './images/12-1.jpg';
import image151 from './images/15-1.jpg';
import image152 from './images/15-2.jpg';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';

export const AddHomescreenShortcutDescription = () => {
    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Перейдите в раздел <b>«Заработок»</b>
                </div>
                <ChallengeDetailHelpImage image={image121} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Зайдите в подраздел <b>«Добавить иконку на главный экран»</b>
                </div>
                <ChallengeDetailHelpImage image={image151} helpText='Это картинка. Ищите подраздел в разделе «Заработок».' />
            </p>
            
            <p>
                <div>
                    Нажмите кнопку <b>«Добавить иконку»</b>
                </div>
                <ChallengeDetailHelpImage image={image152} helpText='Это картинка. Ищите кнопку в подразделе «Добавить иконку на главный экран».' />
            </p>
        </div>
    );
}